import { useMutation } from '@tanstack/react-query';
import { uploadFileV2 } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { DataFileTct } from '@dealstack/shared/lib/generated';

interface Props {
	onSuccess?: (file: DataFileTct | null) => void;
	onError?: (error: unknown) => void;
}

export const useUploadFile = (options: Props = {}) => {
	return useMutation({
		mutationFn: uploadFileV2,
		onSuccess: (result: ApiV1.Response<DataFileTct>) =>
			options?.onSuccess?.(result?.payload ?? null),
		onError: (error) => options?.onError?.(error),
	});
};
